import logo from "../../assets/images/logos/icon-fiskagroup.png"

export default function LogoIcon({ width = 100, height = 100 }) {
    return (
        <img src={logo} width={width} height={height} alt="Icone du logo de L'Artbanne" />
    )
};